module.exports = __webpack_public_path__ + "static/media/defaultprofile.033c1007.jpg";